__turbopack_context__.v({
  "benefitBlock": "ForClubsSimpleProcess-module-scss-module__-3teSa__benefitBlock",
  "card": "ForClubsSimpleProcess-module-scss-module__-3teSa__card",
  "cardContentBottom": "ForClubsSimpleProcess-module-scss-module__-3teSa__cardContentBottom",
  "cardContentTop": "ForClubsSimpleProcess-module-scss-module__-3teSa__cardContentTop",
  "cardImage": "ForClubsSimpleProcess-module-scss-module__-3teSa__cardImage",
  "cardsGrid": "ForClubsSimpleProcess-module-scss-module__-3teSa__cardsGrid",
  "container": "ForClubsSimpleProcess-module-scss-module__-3teSa__container",
  "description": "ForClubsSimpleProcess-module-scss-module__-3teSa__description",
  "imageHoverLayer": "ForClubsSimpleProcess-module-scss-module__-3teSa__imageHoverLayer",
  "imageOverlay": "ForClubsSimpleProcess-module-scss-module__-3teSa__imageOverlay",
  "imagePlaceholder": "ForClubsSimpleProcess-module-scss-module__-3teSa__imagePlaceholder",
  "imageWrapper": "ForClubsSimpleProcess-module-scss-module__-3teSa__imageWrapper",
  "imageWrapperAnchorBottom": "ForClubsSimpleProcess-module-scss-module__-3teSa__imageWrapperAnchorBottom",
  "imageWrapperAnchorTop": "ForClubsSimpleProcess-module-scss-module__-3teSa__imageWrapperAnchorTop",
  "indicator": "ForClubsSimpleProcess-module-scss-module__-3teSa__indicator",
  "sectionEyebrow": "ForClubsSimpleProcess-module-scss-module__-3teSa__sectionEyebrow",
  "sectionTitle": "ForClubsSimpleProcess-module-scss-module__-3teSa__sectionTitle",
  "simpleProcess": "ForClubsSimpleProcess-module-scss-module__-3teSa__simpleProcess",
  "title": "ForClubsSimpleProcess-module-scss-module__-3teSa__title",
});
